/**
 * Vista "Cambiar contraseña" (menú Más) — el promotor rota su contraseña en
 * cualquier momento: contraseña ACTUAL (re-auth contra el backend; una sesión
 * robada no alcanza para tomar la cuenta) + la nueva DOS veces.
 *
 * El backend invalida las sesiones hermanas y conserva la actual — el promotor
 * sigue adentro tras el cambio.
 */

import ApiClient from '../api-client.js';
import { t } from '../languages.js';

const PASSWORD_MIN = 8;

export function renderCambiarContrasena() {
    const el = document.createElement('div');
    el.className = 'login-box';
    el.innerHTML = `
        <div style="text-align:center; margin-bottom:8px;">
            <h1 style="margin:0 0 4px;">${t('cambiarPass.titulo')}</h1>
            <p style="color:var(--text-dim); margin:0;">${t('cambiarPass.subtitulo')}</p>
        </div>
        <input type="password" id="cp-actual" placeholder="${t('cambiarPass.actual')}" autocomplete="current-password">
        <input type="password" id="cp-nueva" placeholder="${t('cambiarPass.nueva')}" autocomplete="new-password">
        <input type="password" id="cp-nueva2" placeholder="${t('cambiarPass.nuevaRepetir')}" autocomplete="new-password">
        <div class="error" id="cp-error"></div>
        <div class="error" id="cp-ok" style="color:var(--accent-green, #2ecc71);"></div>
        <button class="btn btn-install" id="cp-cambiar">${t('cambiarPass.cambiar')}</button>`;

    const actualEl = el.querySelector('#cp-actual');
    const nuevaEl = el.querySelector('#cp-nueva');
    const nueva2El = el.querySelector('#cp-nueva2');
    const errEl = el.querySelector('#cp-error');
    const okEl = el.querySelector('#cp-ok');
    const btn = el.querySelector('#cp-cambiar');

    let enProgreso = false;
    async function cambiar() {
        if (enProgreso) return;
        const passwordActual = actualEl.value || '';
        const password = nuevaEl.value || '';
        const passwordRepetida = nueva2El.value || '';
        errEl.textContent = '';
        okEl.textContent = '';

        if (!passwordActual) {
            errEl.textContent = t('cambiarPass.faltaActual');
            return;
        }
        if (password.length < PASSWORD_MIN) {
            errEl.textContent = t('activacion.passwordCorta');
            return;
        }
        if (password !== passwordRepetida) {
            errEl.textContent = t('activacion.passwordNoCoincide');
            return;
        }

        enProgreso = true;
        btn.disabled = true;
        btn.textContent = t('cambiarPass.cambiando');
        try {
            const r = await ApiClient.cambiarContrasena({ passwordActual, password, passwordRepetida });
            if (!r.ok) {
                errEl.textContent = r.mensaje || t('cambiarPass.error');
                return;
            }
            okEl.textContent = t('cambiarPass.listo');
            actualEl.value = '';
            nuevaEl.value = '';
            nueva2El.value = '';
        } finally {
            enProgreso = false;
            btn.disabled = false;
            btn.textContent = t('cambiarPass.cambiar');
        }
    }

    btn.addEventListener('click', cambiar);
    nueva2El.addEventListener('keydown', e => {
        if (e.key === 'Enter') cambiar();
    });

    return el;
}
